/** Pure focus-index navigation for keyboard/gamepad menu traversal. No Babylon. */

/**
 * Calculate next index with wrapping.
 * @param current Current index
 * @param count Total count of items
 * @param dir Direction: 1 for forward, -1 for backward
 * @returns Next index (wrapped), or current if count <= 0
 */
export function nextIndex(current: number, count: number, dir: 1 | -1): number {
  if (count <= 0) return current;
  return ((current + dir) % count + count) % count;
}

/**
 * Step from current in dir, skipping disabled entries, with wrapping.
 * @param current Current index
 * @param dir Direction: 1 for forward, -1 for backward
 * @param enabled Boolean mask where enabled[i] === true means index i is focusable
 * @returns Next enabled index, or current if none enabled or empty array
 */
export function resolveFocusTarget(
  current: number,
  dir: 1 | -1,
  enabled: boolean[]
): number {
  const count = enabled.length;
  if (count === 0) return current;

  let i = current;
  for (let step = 0; step < count; step++) {
    i = nextIndex(i, count, dir);
    if (enabled[i]) return i;
  }

  return current;
}
